module.exports = __webpack_public_path__ + "img/18.NinjaKawasaki2019.86bc34dd.png";